module.exports = __webpack_public_path__ + "img/frame.52308295.webp";